import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { User, ability } from "./modules/UserVuex";
import Solution from "./modules/SolutionVuex";
import Form from "./modules/FormVuex";
import DoneForm from "./modules/DoneFormVuex";
import App from "./modules/app";
import Company from "./modules/CompanyVuex";
import Proposal from "./modules/ProposalVuex";
import ActionPlan from "./modules/ActionPlanVuex";
import Dashboard from "./modules/DashboardVuex";

import Notification from "./modules/NotificationVuex";
import Notification2 from "./modules/Notification2Vuex";

import Execution from "./modules/ExecutionVuex";
import CustomField from "./modules/CustomFieldVuex";
import DateFilter from './modules/DateFilterVuex'

import Task from './modules/TaskVuex'

import FailuresDashboard from './modules/FailuresDashboardVuex'

import ConfigFlow from './modules/ConfigFlowVuex'
import FlowExecution from './modules/FlowExecutionVuex';

import Department from './modules/DepartmentVuex';

import Approval from "./modules/ApprovalVuex";

export const store = new Vuex.Store({
  modules: {
    App,
    User,
    Solution,
    Form,
    DoneForm,
    Company,
    Proposal,
    Dashboard,
    ActionPlan,
    
    DateFilter,

    Notification,
    Notification2,

    Execution,
    
    CustomField,

    Task,

    FailuresDashboard,

    ConfigFlow,
    FlowExecution,

    Department,
    Approval
  },
});

export const The_Ability = ability;
